import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import { fetchPurchaseOrderSuggestions } from '../../actions/autoSuggest_actions';
import { isOLG } from '../../actions/root_url';

class MixProductAutoSuggest extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
      // isLoading: false,
      noSuggestions: false,
    };

    this.lastRequestId = null;
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.purchaseOrderSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.purchaseOrderSuggestions !== this.props.purchaseOrderSuggestions) {
      this.setState({ suggestions: [...(nextProps.purchaseOrderSuggestions).slice(0, 200)] });
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.loadSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  onFocus(event) {
    event.target.select();
  }

  onKeyPress = () => {false;}

  onSuggestionSelected = (event, { suggestion }) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.handleFocusQty(suggestion);
  }

  getSuggestionValue = (suggestion) => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;

      default:
        return null;
    }
  }

  loadSuggestions(value) {
    this.props.fetchPurchaseOrderSuggestions(this.props.SearchType, value);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.purchaseOrderSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNum;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) =>
    <Row className="suggestion" id="suggestion-render" className='sales-auto-suggest-suggestions'>
      <Col xs={2}>
        {this.renderSearchTypeValue(suggestion)}
      </Col>
      <Col xs={5}>
        {suggestion.Name}
      </Col>
      <Col xs={5}>
        {suggestion.Description}
      </Col>
    </Row>

  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;
      default:
        return <Translate value={isOLG ? "item_no" : "ref_num"} />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps}>
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={2}>
              {this.renderSearchTypeHeader()}
            </Col>
            <Col xs={5}>
              <Translate value="prod_name" />
            </Col>
            <Col xs={5}>
              <Translate value="desc" />
            </Col>
          </Row>
        </div>
        <IsolatedScroll style={{ height: '200px' }} id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'purchase-auto-suggest',
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    purchaseOrderSuggestions: state.autoSuggest.purchaseOrderSuggestions,
    purchaseOrderSuggestionsIsLoading: state.autoSuggest.purchaseOrderSuggestionsIsLoading,
    purchaseOrderSuggestionsError: state.autoSuggest.purchaseOrderSuggestionsError,
  };
}

export default connect(mapStateToProps, { fetchPurchaseOrderSuggestions })(MixProductAutoSuggest);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/MixProductAutoSuggest.jsx